/**
 * Error types for the SAP backend option.
 *
 * Part of the isolated `sap-backend/` side project (see README.md). These
 * surface cleanly to the data layer so an unfinished entity in `sap` mode
 * fails loud and specific rather than silently returning wrong data.
 */

/** Thrown when an entity is dispatched to the SAP backend but no SAP-side
 *  implementation exists yet. The data layer can choose to surface this or
 *  fall back to the Supabase substrate (see config `sapFallbackEnabled`). */
export class SapNotImplementedError extends Error {
  entity: string
  constructor(entity: string) {
    super(`SAP backend: entity "${entity}" is not implemented yet`)
    this.name = 'SapNotImplementedError'
    this.entity = entity
  }
}

/** Generic failure talking to S/4 through the proxy chain. Carries the HTTP
 *  status and any OData error code so callers can branch (e.g. 404 vs 403). */
export class SapBackendError extends Error {
  status: number
  code: string | null
  constructor(status: number, code: string | null, message: string) {
    super(message)
    this.name = 'SapBackendError'
    this.status = status
    this.code = code
  }
}
